export const styles = {
  container: (isMobile) => ({
    fontFamily: "'Poppins', 'Avenir Next', 'Segoe UI', sans-serif",
    width: isMobile ? "100%" : "260px",
    position: isMobile ? "fixed" : "relative",
    bottom: isMobile ? 0 : "auto",
    padding: isMobile ? "0" : "20px 16px",
    left: 0,
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    borderRight: isMobile ? "none" : "1px solid #E5EAF1",
    borderTop: isMobile ? "1px solid #E5EAF1" : "none",
    height: isMobile ? "64px" : "100vh",
    alignItems: "center",
    zIndex: 1000,
    boxShadow: isMobile
      ? "0 -8px 28px rgba(31, 58, 112, 0.12)"
      : "2px 0 18px rgba(31, 58, 112, 0.05)",
  }),

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
  },

  h3: (isMobile) => ({
    display: isMobile ? "none" : "block",
    fontSize: "20px",
    fontWeight: 700,
    color: "#1F3A70",
    margin: 0,
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    letterSpacing: "0.5px",
  }),

  logo: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    objectFit: "contain",
  },

  brand: (isExpanded) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: isExpanded ? "flex-start" : "center",
    gap: isExpanded ? 12 : 10,
    width: "100%",
    marginBottom: 14,
    padding: isExpanded ? "8px 0" : 6,
    boxSizing: "border-box",
    borderRadius: 14,
    background: "transparent",
    transition: "padding 0.45s cubic-bezier(0.22, 1, 0.36, 1)",
  }),

  brandImage: (isExpanded) => ({
    width: isExpanded ? 38 : 30,
    height: isExpanded ? 38 : 30,
    objectFit: "contain",
    flexShrink: 0,
  }),

  brandName: (isExpanded) => ({
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.05,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "0.2px",
    maxWidth: isExpanded ? 130 : 0,
    opacity: isExpanded ? 1 : 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    transition: "max-width 0.35s ease, opacity 0.25s ease",
  }),

  brandTitle: {
    color: "#15233c",
    fontSize: 18,
    letterSpacing: "0.35px",
    lineHeight: 1,
  },

  brandSubtitle: {
    fontFamily: "'Poppins', 'Avenir Next', 'Segoe UI', sans-serif",
    color: "#1f3a70",
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: "0.8px",
    lineHeight: 1.15,
  },

  menuLabel: (isExpanded, active) => ({
    display: "inline-block",
    maxWidth: isExpanded ? 150 : 0,
    marginLeft: isExpanded ? 10 : 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontSize: 15,
    fontWeight: 600,
    color: active ? "#1F3A70" : "#64748B",
    opacity: isExpanded ? 1 : 0,
    transition: "max-width 0.35s ease, margin-left 0.35s ease, opacity 0.25s ease",
  }),

  ul: (isMobile) => ({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: isMobile ? "row" : "column",
    gap: isMobile ? "4px" : "8px",
    width: "100%",
    justifyContent: isMobile ? "space-around" : "flex-start",
    flex: 1
  }),

  li: (isMobile, active, isHovered) => ({
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    flexDirection: isMobile ? "column" : "row",
    flex: isMobile ? 1 : "initial",
    gap: isMobile ? "4px" : "10px",
    padding: isMobile ? "5px 3px 4px" : "10px 12px",
    borderRadius: isMobile ? 0 : 10,
    border: "1px solid transparent",
    cursor: "pointer",
    fontSize: isMobile ? "10px" : "14px",
    fontWeight: active ? 700 : 600,
    transition: "background-color 0.2s ease, color 0.2s ease, transform 0.2s ease",
    background: active ? "#EAF0FB" : isHovered ? "#F6F8FC" : "transparent",
    color: active ? "#1F3A70" : isHovered ? "#1F3A70" : "#64748B",
    boxShadow: "none",
    borderLeft: !isMobile && active ? "2px solid #3D5BB8" : "2px solid transparent",
    borderBottom: isMobile && active ? "2px solid #1F3A70" : "2px solid transparent",
    justifyContent: isMobile ? "center" : "flex-start",
    outline: "none",
  }),

  icon: (active, isHovered) => ({
    width: 36,
    height: 36,
    borderRadius: 10,
    fontSize: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: active || isHovered ? "#1F3A70" : "#53657D",
    background: "transparent",
    transform: active ? "scale(1.08)" : "scale(1)",
    transition: "all 0.2s ease",
    flexShrink: 0,
  }),

  mobileMenuLabel: (active) => ({
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 11,
    lineHeight: 1,
    fontWeight: active ? 700 : 600,
    color: active ? "#1F3A70" : "#64748B",
  }),

  tooltip: {
    position: "absolute",
    left: "calc(100% + 10px)",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 20,
    minWidth: 110,
    padding: "10px 14px",
    borderRadius: 10,
    background: "#1F3A70",
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    pointerEvents: "none",
    boxShadow: "0 8px 18px rgba(31, 58, 112, 0.2)",
  },

  userWrapper: (isExpanded) => ({
    display: "flex",
    flexDirection: isExpanded ? "row" : "column",
    alignItems: "center",
    gap: isExpanded ? "12px" : "10px",
    padding: "12px 0",
    width: "100%",
    boxSizing: "border-box",
  }),

  userAvatar: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    overflow: "hidden",
    backgroundColor: "#F3F4F6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  userImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  userInfo: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
  },

  userName: {
    fontWeight: 600,
    fontSize: "13px",
    color: "#111827",
  },

  userRole: {
    fontSize: "11px",
    color: "#6B7280",
  },

  logoutContainer: {
    padding: "12px 0",
    borderTop: "1px solid #E5E7EB",
    marginTop: "-20px",
  },

  logoutButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "12px 14px",
    borderRadius: "12px",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 600,
    transition: "all 0.25s ease",
    color: "#6B7280",
    backgroundColor: "transparent",
    border: "none",
    width: "100%",
  },

  logoutButtonHover: {
    color: "#1F3A70",
    backgroundColor: "#F3F4F6",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
  },
};